import {
  buildMarkdownDecoratedCountChildrenTextContentComponent,
  buildMarkdownDecoratedSkipCountingTextContentComponent,
} from '../../../../../srcCommon/formatters/markdown/markdownDecoratedComponents';
import {NodeTransform} from '../../../../../srcCommon/formatters/markdown/markdownFormatterTypes';
import {
  commonMakeMarkdownTransformUnfurls,
  UnfurlTransformComponentMap,
} from '../../../../../srcCommon/formatters/markdown/transforms/commonMarkdownTransformUnfurls';
import {CommentModel} from '../../../../models/api/commentModel';
import {DefaultInlineUnfurlWrapper} from '../../../inboxes/viewer/activity/comment/unfurl/inline/commentDefaultInlineUnfurl';
import {CommentErrorInlineUnfurl} from '../../../inboxes/viewer/activity/comment/unfurl/inline/commentErrorInlineUnfurl';
import {CommentInlineTagUnfurl} from '../../../inboxes/viewer/activity/comment/unfurl/inline/commentInlineTagUnfurl';

/*
 * Components.
 */

const unfurlTransformComponentMap: UnfurlTransformComponentMap = Object.freeze({
  DefaultUnfurlWrapper: buildMarkdownDecoratedCountChildrenTextContentComponent(DefaultInlineUnfurlWrapper),
  TagUnfurlWrapper: buildMarkdownDecoratedSkipCountingTextContentComponent(CommentInlineTagUnfurl),
  UnfurlErrorWrapper: buildMarkdownDecoratedCountChildrenTextContentComponent(CommentErrorInlineUnfurl),
});

/*
 * Transform.
 */

export function makeMarkdownTransformUnfurls(comment: CommentModel): NodeTransform {
  return commonMakeMarkdownTransformUnfurls({
    comment,
    components: unfurlTransformComponentMap,
  });
}
